export let _i18nVn = Object.assign({},
    require('./vn/title.json'),
    require('./vn/button.json'),
    require('./vn/message.json'),
    require('./vn/models.json'),
    require('./vn/date.json'),
    require('./vn/menu.json'),
    require('./vn/thanhToan.json'),
);